type Props = {
  percentage?: number;
  size?: number;
  bgStrokeWidth?: number;
  progressStrokeWidth?: number;
  backgroundColor?: string;
};

const CircularProgress = ({
  percentage = 0,
  size = 100,
  bgStrokeWidth = 7,
  progressStrokeWidth = 5,
  backgroundColor = '#F8FAFC',
}: Props) => {
  // Ensure percentage is between 0 and 100
  if (percentage > 100) percentage = 100;
  if (percentage < 0) percentage = 0;

  const normalizedPercentage = Math.min(100, Math.max(0, percentage));

  // Calculate dimensions
  const radius = (size - bgStrokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (normalizedPercentage / 100) * circumference;

  // Center point
  const center = size / 2;

  return (
    <div className="relative inline-flex">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: 'rotate(90deg)' }} // Start from top instead of right
      >
        <defs>
          <linearGradient id="progressGradient" gradientTransform="rotate(119)">
            <stop offset="33.11%" stopColor="#00A0BB" />
            <stop offset="50.51%" stopColor="#00A2BE" />
            <stop offset="67.91%" stopColor="#00D9FF" />
          </linearGradient>
        </defs>

        {/* Background circle */}
        <circle cx={center} cy={center} r={radius} fill="none" stroke={backgroundColor} strokeWidth={bgStrokeWidth} />

        {/* Progress arc */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="url(#progressGradient)"
          strokeWidth={progressStrokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{
            transition: 'stroke-dashoffset 0.3s ease-in-out',
          }}
        />
      </svg>
      <strong className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xs text-white font-semibold">
        {Boolean(percentage) && `${percentage}%`}
      </strong>
    </div>
  );
};

export { CircularProgress };
